import BMenuItemGroup from '../menu/menu-group'

/* istanbul ignore next */
BMenuItemGroup.install = function (Vue) {
  Vue.component(BMenuItemGroup.name, BMenuItemGroup)
}

export default BMenuItemGroup
